export type Result<T> = { readonly ok: true; readonly value: T } | { readonly ok: false; readonly reason: string };

export const errorText = (error: unknown): string => (error instanceof Error ? error.message : String(error));

type Outcome = { readonly ok: true } | { readonly ok: false; readonly reason: string };
type Succeeded<R> = Extract<R, { readonly ok: true }>;

const succeeded = <R extends Outcome>(result: R): result is Succeeded<R> => result.ok;

export function expected<R extends Outcome>(result: R, what: string): Succeeded<R> {
  if (succeeded(result)) return result;
  throw new Error(result.ok ? what : `${what}: ${result.reason}`);
}

export function present<T>(value: T | undefined, what: string): T {
  if (value === undefined) throw new Error(`${what} is missing after the check that it is there`);
  return value;
}
